import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Pagination from '../components/Pagination';
import { useSearchExport } from '../context/SearchExportContext';
import { getUsersPlans } from '../redux/usersPlanSlice';
import ExportDropdown from '../context/ExportDropdown';
import RecordsLoader from '../components/RecordsLoader';

const UsersPlansList = () => {
    const dispatch = useDispatch();
    const { usersPlans, status } = useSelector((state) => state.usersPlans);
    const { filterData } = useSearchExport();

    const [currentPage, setCurrentPage] = useState(1);
    const usersPlansPerPage = 50;

    useEffect(() => {
        dispatch(getUsersPlans());  // Fetch all open calls on component load
    }, [dispatch]);

    const currentUsersPlans = filterData(usersPlans)
        .slice((currentPage - 1) * usersPlansPerPage, currentPage * usersPlansPerPage);

    return (
        <div className="container mx-auto p-6">

            {/* Render the loader if the status is 'idle' */}
            {status === 'idle' && <RecordsLoader text="Loading User's Plans, please hold on..." />}

            <h1 className="text-2xl text-black font-bold mb-6">usersPlans List</h1>

            {/* Export Buttons */}
            <ExportDropdown data={usersPlans} fileName="usersPlans" />

            {/* Loading state */}
            {status === 'failed' && <p>Error loading usersPlans</p>}

            {/* Open Call List Table */}
            {status === 'succeeded' && (
                <>
                    <table className="min-w-full table-auto bg-white shadow-md rounded-lg">
                        <thead>
                            <tr className="bg-gray-100 text-left">
                                <th className="px-4 py-2">ID</th>
                                <th className="px-4 py-2">Organization Title</th>
                                <th className="px-4 py-2">User Type</th>
                                <th className="px-4 py-2">Razorpay Payment Id</th>
                                <th className="px-4 py-2">Purchased Plan</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentUsersPlans.length > 0 ? (
                                currentUsersPlans.map((usersPlan) => (
                                    <tr
                                        key={usersPlan.id}
                                        className="border-b cursor-pointer hover:bg-gray-100"
                                    >
                                        <td className="px-4 py-2">{usersPlan.id}</td>
                                        <td className="px-4 py-2">{usersPlan.organization_title}</td>
                                        <td className="px-4 py-2">{usersPlan.user_type === "organization" ? "Organization" : "Artist"}</td>
                                        <td className="px-4 py-2">{usersPlan.razorpay_payment_id}</td>
                                        <td>
                                            <span className={`inline-block px-4 rounded-full ${usersPlan.plan_id === 3 ? "bg-green-500 text-white" : usersPlan.plan_id === 2 ? "bg-yellow-500 text-black" : "bg-red-500 text-white"}`}>
                                                {usersPlan.plan_id === 3 ? "Ultimate" : usersPlan.plan_id === 2 ? "Pro" : "Free"}
                                            </span>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="9" className="text-center py-4">No usersPlans Found!</td>
                                </tr>
                            )}
                        </tbody>
                    </table>

                    {/* Pagination */}
                    {usersPlans.length > usersPlansPerPage && (
                        <Pagination
                            usersPerPage={usersPlansPerPage}
                            totalUsers={usersPlans.length}
                            paginate={setCurrentPage}
                            currentPage={currentPage}
                        />
                    )}
                </>
            )}
        </div>
    );
};

export default UsersPlansList;